import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import { Container } from '../Container';
import { useTypedTheme } from '@monorepo-web/styles';
import { Dates } from './Calendario/style';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt-br';
import { useIsDisabled } from './helper';
export default function DataFim({ obj_datas, dataInicialCarteira, dataFinalCarteira, disabled, onAccept }) {
    const theme = useTypedTheme();
    const [dataFinal, setDataFinal] = useState(dataFinalCarteira);
    const isDisabled = useIsDisabled(obj_datas);
    useEffect(() => {
        if (dataFinalCarteira) {
            setDataFinal(dataFinalCarteira);
        }
    }, [dataFinalCarteira]);
    return (_jsx(Container, { children: _jsx(Dates, { children: _jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterDayjs, adapterLocale: "pt-br" }, { children: _jsx(DatePicker, { disabled: disabled, value: dayjs(dataFinal.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$2-$1')), onChange: (newValue) => {
                        var _a;
                        if (newValue && newValue.format('DDMMYYYY') !== 'Invalid Date' && !isDisabled(newValue)) {
                            setDataFinal((_a = newValue === null || newValue === void 0 ? void 0 : newValue.format('DDMMYYYY')) !== null && _a !== void 0 ? _a : '');
                        }
                        else {
                            setDataFinal('');
                        }
                    }, onAccept: newValue => {
                        var _a, _b;
                        setDataFinal((_a = newValue === null || newValue === void 0 ? void 0 : newValue.format('DDMMYYYY')) !== null && _a !== void 0 ? _a : '');
                        onAccept((_b = newValue === null || newValue === void 0 ? void 0 : newValue.format('DDMMYYYY')) !== null && _b !== void 0 ? _b : '');
                    }, dayOfWeekFormatter: (day) => {
                        switch (day) {
                            case '2�':
                            case '6�':
                                day = 'S';
                                break;
                            case '4�':
                            case '5�':
                                day = 'Q';
                                break;
                            case '3�':
                                day = 'T';
                                break;
                        }
                        return day.slice(0, 1);
                    }, inputFormat: "DD/MM/YYYY", label: 'Selecione a data da consulta', shouldDisableDate: isDisabled, renderInput: (params) => (_jsx(TextField, Object.assign({ placeholder: "dd/mm/yyyy", size: "small", sx: {
                            marginTop: 2,
                            width: 184,
                            [`@media ${theme.device.mobileXL}`]: {
                                width: 140,
                            },
                            [`@media ${theme.device.mobileM}`]: {
                                width: 120,
                            },
                        }, onKeyDown: (e) => {
                            if (e.key === 'Enter' && dataFinal !== '') {
                                onAccept(dataFinal);
                            }
                        } }, params))) }) })) }) }));
}
